<template>
    <div v-if="$_job">
        <div
            class="af-job-title afu-px-5"
            :class="{'afu-py-7 afu-bg-neutral-light': !isApplyView, 'afu-py-5 afu-z-100': isApplyView}"
        >
            <a
                href="#"
                class="afu-text-neutral-dark afu-text-lg md:afu-text-base afu-cursor-pointer"
                @click="back"
                v-if="!isApplyView"
            >
                <FontAwesomeIcon
                    :icon="['fas', 'chevron-left']"
                    size="xs"
                    class="afu-mr-2 afu-text-neutral-dark"
                /> Back to results
            </a>
            <div>
                <div
                    v-if="!isApplyView"
                    class="afu-my-5"
                >
                    <img
                        v-if="showCompanyLogo"
                        class="afu-object-contain afu-h-16 afu-w-auto"
                        :src="$_job.company_square_logo_url"
                        :alt="$_job.company_name"
                        :title="$_job.company_name"
                    >
                </div>
                <h1
                    class="afu-text-black afu-mt-0 afu-font-bold"
                    :class="{'afu-text-10xl afu-mb-5': !isApplyView, 'afu-text-xs afu-mb-1 ': isApplyView}"
                    v-html="$_jobTitle"
                />
                <div
                    class="af-job-features afu-flex afu-flex-col"
                    :class="{'afu-text-xs afu-gap-2': !isApplyView, 'afu-text-base afu-gap-1': isApplyView}"
                >
                    <div
                        class="afu-font-semibold af-location"
                    >
                        <span
                            class="afu-no-underline afu-text-secondary afu-font-semibold"
                        >
                            <FontAwesomeIcon
                                :icon="['fas', 'map-marker-alt']"
                                :class="['afu-text-secondary']"
                            />
                            {{ $_locationLabel }}
                            <a
                                v-if="isMapEnabled"
                                class="afu-ml-2 afu-underline afu-text-secondary afu-font-normal"
                                href="#job-map-location"
                            >View Location
                            </a>
                        </span>
                    </div>
                    <div
                        v-if="!parseInt($_job.pay_is_hidden)"
                        class="afu-font-semibold af-pay-salary"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ $t('label.salary') }}:</span>
                        <span v-html="getMinMaxLabel"></span>
                    </div>
                    <div
                        class="afu-font-semibold af-pay-description"
                    >
                        {{ $_job.pay_description }}
                    </div>
                    <div
                        v-if="showCustomAttribute(1)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_1"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(1) }}:</span> {{ getCustomAttributeValue(1) }}
                    </div>
                    <div
                        v-if="showCustomAttribute(2)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_2"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(2) }}:</span> {{ getCustomAttributeValue(2) }}
                    </div>
                    <div
                        v-if="showCustomAttribute(3)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_3"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(3) }}:</span> {{ getCustomAttributeValue(3) }}
                    </div>
                    <div
                        v-if="showCustomAttribute(4)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_4"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(4) }}:</span> {{ getCustomAttributeValue(4) }}
                    </div>
                </div>
            </div>
        </div>
        <!-- <JobViewWidgetMobile v-if="widget" /> -->
        <div
            v-if="!description"
            class="af-toggle-job-description afu-px-4 afu-pb-5"
        >
            <a
                href="#"
                @click.stop.prevent="toggleDescription()"
                class="afu-flex afu-items-center afu-no-underline afu-text-primary afu-text-lg"
            >
                <template v-if="!show">
                    <span>
                        {{ $t('job_view.see_desc') }}
                    </span>
                    <FontAwesomeIcon
                        :icon="['fal', 'angle-down']"
                        size="sm"
                        class="afu-ml-3 afu-text-primary-400"
                    />
                </template>
                <template v-else>
                    <span>
                        {{ $t('job_view.hide_desc') }}
                    </span>
                    <FontAwesomeIcon
                        :icon="['fal', 'angle-up']"
                        class="afu-ml-3 afu-w-3 afu-text-primary-400"
                    />
                </template>
            </a>
        </div>
        <div
            v-if="show"
            class="af-job-desc afu-px-4 afu-pb-4 afu-my-4"
        >
            <template v-if="$_job.job_bullets">
                <ul
                    class="afu-list-disc afu-m-0 afu-pl-4 afu-mb-4"
                >
                    <li
                        class="afu-text-xs afu-font-normal afu-text-black afu-leading-xs"
                        v-for="(job_bullet, index) in $_job.job_bullets"
                        :key="`${$_job.uuid}_${index}`"
                    >
                        {{ job_bullet }}
                    </li>
                </ul>
            </template>

            <JobViewVideo position="A" />

            <div
                class="afu-text-xs afu-font-normal afu-text-black afu-leading-xs"
                v-html="$_jobBody"
            />

            <JobViewVideo position="B" />

            <div
                v-if="isMapEnabled"
                id="job-map-location"
                class="afu-pt-20 afu-mb-9"
            >
                <h2 class="af-job-mapLabel afu-mb-4 af-text--xl">
                    <!-- Location -->
                </h2>
                <JobViewMap
                    class="afu-mb-9"
                    :zoom="mapZoom"
                />
            </div>
            <div
                v-if="$_job.consultant_detail"
                class="af-job-consultants afu-flex afu-flex-col afu-mt-12 afu-text-black"
            >
                <div>
                    <h2 class="af-job-consultantsLabel afu-mb-9 af-text--3xl">
                        {{ $t('label.consultant') }}
                    </h2>
                    <div class="afu-text-black afu-mb-7">
                        <div
                            v-if="$_job.consultant_detail.profile_url"
                            class="afu-mb-7"
                        >
                            <img
                                :src="$_job.consultant_detail.profile_url"
                                class="afu-w-full afu-rounded-btn"
                            >
                        </div>
                        <div class="afu-text-black afu-flex afu-flex-col afu-gap-4">
                            <div
                                v-if="$_job.consultant_detail.first_name"
                                class="af-job-consultantsName"
                            >
                                <h2 class="af-text--2xl afu-text-primary-dark">
                                    {{ $_job.consultant_detail.first_name }} {{ $_job.consultant_detail.last_name }}
                                </h2>
                            </div>
                            <div
                                v-if="$_job.consultant_detail.title"
                                class="af-job-consultantsTitle"
                            >
                                <h3 class="afu-text-lg afu-leading-lg afu-text-primary-light afu-font-normal">
                                    {{ $_job.consultant_detail.title }}
                                </h3>
                            </div>
                            <div
                                v-if="$_job.consultant_detail.blurb"
                                class="af-job-consultantsIntro afu-text-lg afu-leading-lg afu-text-primary-dark afu-font-normal"
                            >
                                {{ $_job.consultant_detail.blurb }}
                            </div>
                        </div>
                        <div class="afu-text-black afu-flex-col afu-my-6">
                            <div
                                v-if="$_job.consultant_detail.email"
                                class="afu-text-xl afu-mb-6 af-job-consultantsEmail"
                            >
                                <FontAwesomeIcon
                                    :icon="['far', 'envelope']"
                                    class="afu-w-4 afu-text-primary-dark svg-inline--fa fa-w-14 afu-mr-4"
                                /> <a :href="'mailto:' + $_job.consultant_detail.email"><span class="afu-text-lg afu-leading-lg afu-text-primary-dark">{{ $_job.consultant_detail.email }}</span></a>
                            </div>
                            <div
                                v-if="$_job.consultant_detail.phone"
                                class="afu-text-xl afu-mb-6 af-job-consultantsPhone"
                            >
                                <FontAwesomeIcon
                                    :icon="['fas', 'phone-alt']"
                                    class="afu-w-4 afu-text-primary-dark svg-inline--fa fa-w-14 afu-mr-4"
                                /> <a :href="'tel:' + $_job.consultant_detail.phone"><span class="afu-text-lg afu-leading-lg afu-text-primary-dark">{{ $_job.consultant_detail.phone }}</span></a>
                            </div>
                            <div
                                v-if="$_job.consultant_detail.linkedin_url"
                                class="afu-text-xl afu-mb-6"
                            >
                                <FontAwesomeIcon
                                    :icon="['fab', 'linkedin']"
                                    class="afu-w-4 afu-text-primary-dark svg-inline--fa fa-w-14 afu-mr-4"
                                /><a :href="$_job.consultant_detail.linkedin_url"><span class="afu-text-lg afu-leading-lg afu-text-primary-dark">{{ $_job.consultant_detail.linkedin_url }}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="af-job-features afu-flex afu-flex-col afu-text-xs afu-my-4">
                <div>
                    <span class="afu-text-black afu-text-xs afu-leading-xs afu-font-semibold">{{ $t('label.reference_number') }}:</span><span> {{ $_job.advertiser_reference }}</span>
                </div>
                <div
                    class="afu-flex"
                >
                    <span class="afu-mr-1 afu-text-black afu-text-xs afu-leading-xs afu-font-semibold">{{ $t('label.profession') }}:</span>
                    <div
                        v-for="(classification, index) in $_classifications"
                        :key="classification.id + index"
                        class="afu-flex"
                    >
                        <div
                            class="af-job-classification afu-text-black afu-flex afu-items-center"
                            :class="{'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-text-base afu-leading-base' : isApplyView }"
                        >
                            <a
                                class="afu-text-black afu-no-underline"
                                :class="{'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-text-base afu-leading-base' : isApplyView }"
                                :href="getClassificationLink(classification)"
                            >{{ classification.value }}</a>
                            <div
                                v-for="(subclassification, index_sub) in classification.subclassifications"
                                :key="subclassification.id + index_sub"
                            >
                                <FontAwesomeIcon
                                    :icon="['fal', 'angle-right']"
                                    class="afu-mx-1 afu-w-2 afu-text-black"
                                />
                                <a
                                    class="afu-text-black afu-no-underline"
                                    :class="{'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-text-base afu-leading-base' : isApplyView }"
                                    :href="getSubClassificationLink(classification, subclassification)"
                                >{{ subclassification.value }}</a>
                                <span
                                    v-if="index_sub != Object.keys(classification.subclassifications).length - 1"
                                    class="afu-mr-2"
                                >,</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <span class="afu-text-black afu-text-xs afu-leading-xs afu-font-semibold">{{ $t('label.company') }}:</span>
                    <span
                        class="afu-text-black afu-text-xs afu-leading-xs"
                        v-if="!$_isPrivateListing"
                    >{{ $_primaryCompanyName }} {{ $_companyName }}</span>
                    <span
                        class="afu-text-black afu-text-xs afu-leading-xs"
                        v-else
                    >Private Listing</span>
                </div>
                <div>
                    <span class="afu-text-black afu-text-xs afu-leading-xs afu-font-semibold">{{ $t('job_view.date_posted') }}:</span><span> {{ $_postedAt | dateFormat }}</span>
                </div>
            </div>
        </div>

        <!-- <div class="af-matched-job-mobile">
            <JobViewMatchedJobs />
        </div> -->
    </div>
</template>

<script>
    import JobViewContentMixin from '@/apps/jobview/mixins/JobViewContentMixin';
    import Filters from '@/components/Utils/Filters';

    // import JobViewWidgetMobile from './JobViewWidgetMobile';
    // import JobViewMatchedJobs from './JobViewMatchedJobs';
    import Cookie from '@/services/cookie';
    import JobViewMap from './JobViewMap';
    import JobViewVideo from './JobViewVideo.vue';

    export default {
        name: 'JobViewContentMobile',

        components: {
            // JobViewWidgetMobile,
            JobViewMap,
            JobViewVideo,
        },

        computed: {
            isMapEnabled() {
                return (
                    window?.afConfig?.job_details_map_enabled?.toLowerCase() ===
                    'yes'
                );
            },

            mapZoom() {
                let zoom = window?.afConfig?.job_details_map_zoom;

                if (zoom && typeof zoom === 'string') {
                    zoom = parseInt(zoom);
                }

                return zoom;
            },
        },

        mixins: [JobViewContentMixin, Filters],

        props: {
            scrollbar: {
                type: Boolean,
                default: false,
            },

            widget: {
                type: Boolean,
                default: true,
            },

            description: {
                type: Boolean,
                default: true,
            },
            isApplyView: {
                type: Boolean,
                default: false,
            },
        },

        data() {
            return {
                show: true,
            };
        },

        created() {
            this.show = this.description;
        },

        methods: {
            toggleDescription() {
                this.show = !this.show;
                this.$emit('toggleDescription' , this.show);
            },
            back(){
                // var oldURL = document.referrer;
                // var urlArr = oldURL.split('/');
                // var currUrl = window.location.href;
                // var currUrlArr = currUrl.split('/');

                // if(currUrlArr[2] == urlArr[2] && oldURL.indexOf(this.$t('single_job.backToSearchUrl')) > -1) {
                //     this.$router.go(-1);
                // }
                // else {
                //     window.location.href = window.location.origin + '/' + this.$t('single_job.backToSearchUrl');
                // }

                let url = Cookie.getJobFilter();
                url = url.replace('//', '/');
                window.location.href = window.location.origin + '/jobs' + url;
            },
            getSiteCode() {
                return window?.afConfig?.site_code;
            },
        },
    };
</script>

<style>
    .af-job-consultants a {
        text-decoration: none;
    }
</style>
